import React, { useMemo, useState } from 'react';
import { noop } from 'lodash';

import type { SuggestionOption } from '~/components/core/Editor/types';

interface ModalContextType {
  openModal: () => void;
  closeModal: () => void;
  isOpen: boolean;
  /** The editor's token list, so the link dialog can offer tokens inside a URL. Empty for an editor
   *  with no tokens configured, which keeps that editor's link dialog exactly as it was. */
  tokenOptions: SuggestionOption[];
}

const LinkModalContext = React.createContext<ModalContextType>({
  openModal: noop,
  closeModal: noop,
  isOpen: false,
  tokenOptions: [],
});

export const useLinkModal = (): ModalContextType => React.useContext(LinkModalContext);

interface ModalProviderProps {
  children: React.ReactNode;
  tokenOptions: SuggestionOption[];
}

export const ModalLinkProvider: React.FC<ModalProviderProps> = ({ children, tokenOptions }) => {
  const [isOpen, setIsOpen] = useState(false);

  const contextValue = useMemo(() => {
    return {
      isOpen,
      tokenOptions,
      openModal: () => setIsOpen(true),
      closeModal: () => setIsOpen(false),
    };
  }, [isOpen, tokenOptions]);

  return <LinkModalContext.Provider value={contextValue}>{children}</LinkModalContext.Provider>;
};
